import React from 'react';
import {
  Grid, Card, CardContent,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Alert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import { errorMessage } from '../../constants/Constants';
import useStyles from '../style';

const UserGuide = (props) => {
  const { urlsData, ugError, isUgSending } = props;
  const classes = useStyles();

  const openPDF = (event, documentUrl) => {
    event.preventDefault();
    // eslint-disable-next-line no-undef
    window.open(documentUrl, '_blank');
  };

  const getAccordian = () => {
    if (urlsData && Array.isArray(urlsData) && urlsData.length > 0) {
      return urlsData.map((reportUrl) => {
        const { reportName, pdfUrl, videoUrl } = reportUrl;
        return (
          <Accordion
            TransitionProps={{ unmountOnExit: true }}
            key={`userguide-${reportName}`}
            className={classes.accordian}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.accSummHeading}>{reportName}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {pdfUrl && (
                <Button
                  type="button"
                  onClick={(event) => openPDF(event, pdfUrl)}
                  className={classes.guidePDFButton}
                >
                  View PDF
                </Button>
              )}
              {videoUrl && (
                <Button
                  type="button"
                  onClick={(event) => openPDF(event, videoUrl)}
                  className={classes.guideVideoButton}
                >
                  Watch Video
                </Button>
              )}
            </AccordionDetails>
          </Accordion>
        );
      });
    }
    return null;
  };

  // console.log(urlsData);
  return (
    <Grid container>
      <Grid item md={8} sm={8} xs={12}>
        <h2 className={classes.requestReportHead}>User Guide</h2>
      </Grid>
      <Grid item md={10} sm={10} xs={12} className={classes.userGuide}>
        <Card className={classes.mainContainerColor}>
          <CardContent className={classes.mainContainerColor}>
            <Loader
              type="Grid"
              color="#FFBF00"
              secondaryColor="#2d2d2d"
              height={100}
              width={100}
              visible={isUgSending}
              className="loader"
            />
            { ugError && (
              <Alert
                variant="filled"
                severity="error"
              >
                {errorMessage}
              </Alert>
            )}
            {getAccordian()}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

/** Required function and props with the proptypes */
UserGuide.propTypes = {
  isUgSending: PropTypes.bool.isRequired,
  ugError: PropTypes.bool.isRequired,
  urlsData: PropTypes.arrayOf(PropTypes.shape({
    pdfUrl: PropTypes.string,
    reportName: PropTypes.string,
    videoUrl: PropTypes.string,
  })).isRequired,
};

export default UserGuide;
